<template>
    <div class="Summary">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-6">
                    <h4>Location <GoogleMapsLink v-bind:address="LocationRecordData.Address" /></h4>
                    <div>
                        <p>
                            <span class="bold">Name: </span>
                            <StringEditor v-bind:old-value="LocationRecordData.Name"
                                          v-bind:record-id="LocationRecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Name"
                                          property-name="Name"
                                          update-method="TAY/Location/UpdateLocation"
                                          v-bind:required="true" />
                        </p>
                        <p>
                            <AddressEditor v-bind:old-value="LocationRecordData.Address"
                                           v-bind:record-id="LocationRecordData.Address.Id"
                                           v-bind:edit-mode="EditMode"
                                           data-label="Physical Address"
                                           update-method="Core/Address/Update"
                                           required="true" />
                        </p>
                        <p>
                            <span class="bold">Phone Number: </span>
                            <StringEditor v-bind:old-value="LocationRecordData.PhoneNumber.FormattedPhoneNumber"
                                          v-bind:record-id="LocationRecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Phone Number"
                                          property-name="PhoneNumberDigits"
                                          update-method="TAY/Location/UpdatePhoneNumber"
                                          v-bind:required="true" />
                        </p>
                        <p>
                            <span class="bold">Territory: </span>
                            <SelectEditor v-bind:old-value="LocationRecordData.SubProgramTerritoryID"
                                          v-bind:old-value-text="LocationRecordData.SubProgramTerritory != null ? LocationRecordData.SubProgramTerritory.Name : null"
                                          v-bind:record-id="LocationRecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Territory"
                                          property-name="SubProgramTerritoryID"
                                          update-method="TAY/Location/UpdateLocation"
                                          v-bind:options="SubProgramTerritoryOptions"
                                          :chart-id="LocationRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Active: </span>
                            <SelectEditor v-bind:old-value="LocationRecordData.IsActive"
                                          v-bind:old-value-text="LocationRecordData.IsActive == true ? 'Yes' : 'No'"
                                          v-bind:record-id="LocationRecordData.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Active"
                                          property-name="IsActive"
                                          update-method="TAY/Location/UpdateLocation"
                                          v-bind:options="TrueFalseOptions"
                                          :chart-id="LocationRecordData.Id" />
                        </p>
                    </div>
                </div>
                <div class="col-md-6">
                    <h4>Clients ({{ CurrentClientCount }})</h4>
                    <div v-for="client in CurrentClients">
                        <p>{{ client.ClientSubProgramMembership.Client.Person.FullName }}</p>
                    </div>
                </div>
            </div>
        </div>
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
    </div>
</template>

<script>
    import GoogleMapsLink from "../../../Core/LinkShortcuts/GoogleMapsLink.vue";
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    import StringEditor from '../../../Core/ItemEditors/StringEditor';
    import AddressEditor from '../../../Core/ItemEditors/AddressEditor';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor';

    export default {
        props: [
            'LocationRecordData'
        ],
        data: function () {
            return {
                EditMode: false,
            }
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
        },
        components: {
            GoogleMapsLink,
            EditMode,
            StringEditor,
            AddressEditor,
            SelectEditor
        },
        mounted() {
        },
        computed: {
            //CurrentTeamMembers: function () {
            //    let output = {
            //        Supervisor: "Unassigned",
            //        BHS: "Unassigned",
            //        Facilitator: "Unassigned",
            //        PP: "Unassigned",
            //        Clinician: "Unassigned"
            //    };
            //    let bhsList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Behavioral Health Specialist");
            //    if (bhsList.length > 0) {
            //        output.BHS = bhsList.map(e => e.Employee.Person.FullName).join(', ');
            //    }
            //    let facilitatorList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Facilitator");
            //    if (facilitatorList.length > 0) {
            //        output.Facilitator = facilitatorList.map(e => e.Employee.Person.FullName).join(', ');
            //    }
            //    let ppList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Parent Partner");
            //    if (ppList.length > 0) {
            //        output.PP = ppList.map(e => e.Employee.Person.FullName).join(', ');
            //    }
            //    let clinicianList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Clinician");
            //    if (clinicianList.length > 0) {
            //        output.Clinician = clinicianList.map(e => e.Employee.Person.FullName).join(', ');
            //    }
            //    let supervisorList = this.TeamRecordData.EmployeeMemberships.filter(r => r.EndDate == null && r.EmployeeRole == "Supervisor");
            //    if (supervisorList.length > 0) {
            //        output.Supervisor = supervisorList.map(e => e.Employee.Person.FullName).join(', ');
            //    }

            //    return output;

            //},
            CurrentClients: function () {
                let currents = this.LocationRecordData.ClientSubProgramResidenceMemberships.filter(r => r.EndDate == null && r.ClientSubProgramMembership.EndDate == null);
                if (currents.length > 0 && currents[0].ClientSubProgramMembership.Client) {
                    return currents;
                } else {
                    return [];
                }
            },
            CurrentClientCount: function () {
                return this.LocationRecordData.ClientSubProgramResidenceMemberships.filter(r => r.EndDate == null && r.ClientSubProgramMembership.EndDate == null).length;
            },
            TrueFalseOptions: function () {
                return this.$store.state.Options.TrueFalseOptions;
            },
            SubProgramTerritoryOptions: function () {
                let output = [];
                if (this.LocationRecordData.SubProgram && this.LocationRecordData.SubProgram.SubProgramTerritories) {
                    this.LocationRecordData.SubProgram.SubProgramTerritories.forEach(function (t) {
                        output.push({
                            text: t.Name,
                            value: t.Id
                        });
                    });
                }
                
                return output;
            }
        }
    }
</script>

<style scoped>
</style>